<template>
    <div>
        <div v-if="users.length" class="container">
            <div class="nav_category">
                <div class="categories_inner text_center">
                    <div class="category_link second_font active">
                        <div class="link_title">
                            {{ group.name }}
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="block_decoration_green">
            <div class="container">
                <div class="columns_wrapper flex item_center">
                    <single-person
                        v-for="(person, index) of users"
                        :key="person.fullName + index"
                        :person="person"
                        @contact-us="onContactUs"
                    />
                </div>
            </div>

            <div v-if="total > users.length" class="btn_wrapper text_center">
                <a
                    class="btn btn_green decorated_button"
                    @click="fetchGroup(true)"
                >
                    הצג עוד
                </a>
            </div>
        </div>
    </div>
</template>

<script>
import BaseGroup from '@/components/about/BaseGroup';
import SinglePerson from '@/components/about/SinglePerson';

export default {
    components: {
        SinglePerson
    },

    extends: BaseGroup
};
</script>
